import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MsisdnService } from '../shared/msisdn/msisdn.service';
import { Msisdn } from '../shared/msisdn/msisdns';

@Injectable()
export class InboundableMsisdnResolver implements Resolve<Msisdn[]> {
  constructor(private msisdnService: MsisdnService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Msisdn[]> | Promise<Msisdn[]> | Msisdn[] {
    return this.msisdnService.inboundableMsisdns();
  }
}
